/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import styles from './styles.module.scss'

export default function Back({ 
  path = '',
  onClick=()=>{},
  title='',
  handleFunction=false,
  marginBottom = 0,
}) {
  const history = useHistory();

  const handleBack = () => {
    if (path) history.push(path);
    else history.goBack();
  };
  
  const handleClick = () => {
    if (handleFunction){onClick();}
    else{handleBack();}
  }

  return (
    <nav className={styles['bar-mobile']} style={{marginBottom}}>
        <button
            className={styles.back}
            onClick={handleClick}
        >
          <svg
                xmlns="http://www.w3.org/2000/svg"
                fill='#fff'
                height="1em"
                viewBox="0 0 448 512"
            >
                <path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" />
          </svg>
        </button>
        {title}
    </nav>
  );
}

Back.propTypes = {
  path: PropTypes.string,
  onClick: PropTypes.func,
  title: PropTypes.string,
  handleFunction: PropTypes.bool,
};
